import { HandComponent } from "./Poker.HandComponent";
import { Routes } from "@angular/router";
import { HandGuardGuard } from './hand-guard.guard';

export const MainRoutes = [
  {
    path: 'Hand',
    loadChildren: () => import("./Poker.HandModule").then(mod => mod.HandModule)
  },
  {
    path: 'Home/AngularApps',
    loadChildren: () => import("./Poker.HandModule").then(mod => mod.HandModule)
  },
   
];
